import { createEnvConfig } from "./env-create.mjs";

export const env = createEnvConfig();
